import { Flex, Stack, Textarea, TextInput, Title } from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { Controller, useFormContext } from "react-hook-form";
import { useIsOnline } from "src/hooks";
import { type IFgasForm } from "src/pages/Settings/YachtSetup/Fgas/Fgas.types";
import { legalStatusFields } from "src/pages/Settings/YachtSetup/Fgas/Fgas.utils";
import {
  mantineDateOnChange,
  toMantineDateString,
} from "src/utils/mantineDates";

import styles from "../YachtSetUp.module.scss";
import { StyledYachtSetUpItem } from "../YachtSetUp.styled";
import FgasHistory from "./FgasHistory";

const FgasLegalStatusForm = () => {
  const { register, control } = useFormContext<IFgasForm>();
  const isOnline = useIsOnline();

  return (
    <Flex direction="column" w={{ base: "100%", lg: "30%" }} miw={{ lg: 320 }}>
      <Flex mih={36} justify="space-between" align="center">
        <Title order={3} className={styles.sectionTitle}>
          Legal Status
        </Title>
        <FgasHistory type="legalStatus" />
      </Flex>
      <StyledYachtSetUpItem style={{ width: "100%" }}>
        <Stack w="100%">
          {legalStatusFields.map(field =>
            field.multiline ? (
              <Textarea
                key={field.name}
                autosize
                minRows={4}
                label={field.label}
                disabled={!isOnline}
                {...register(`legalStatus.${field.name}`)}
              />
            ) : (
              <TextInput
                key={field.name}
                label={field.label}
                disabled={!isOnline}
                {...register(`legalStatus.${field.name}`)}
              />
            ),
          )}
          <Controller
            name="legalStatus.expiry_date"
            control={control}
            render={({ field }) => (
              <DatePickerInput
                label="Expiry Date"
                valueFormat="DD MMM YYYY"
                dropdownType="modal"
                clearable
                disabled={!isOnline}
                value={toMantineDateString(field.value)}
                onChange={mantineDateOnChange(field.onChange)}
                onBlur={field.onBlur}
              />
            )}
          />
        </Stack>
      </StyledYachtSetUpItem>
    </Flex>
  );
};

export default FgasLegalStatusForm;
